import { useEffect, useState } from "react";
import { Calendar, Grid, Row, Col, Button, TimePicker } from "rsuite";
import { zhTW } from "rsuite/esm/locales";
import type { RideDatetimeSelectProps } from "../my-type";


export default function RideTimeSelect({ onDatetimeSelect }: RideDatetimeSelectProps) {
  const [rideDate, setRideDate] = useState<Date>(new Date())
  const [rideTime, setRideTime] = useState<Date | null>(new Date());
  const [isShowWarning, setIsShowWarning] = useState<boolean>(false);
  const [warningMessage, setWarningMessage] = useState<string>('');
  //const [rideTime, setRideTime] = useState<string | null>('10:10');

  useEffect(() => {
    let today = new Date();
    let nextThreeDays = new Date(today.setDate(today.getDate() + 3));
    setRideDate(nextThreeDays);
    setRideTime(nextThreeDays);

  }, [])


  return (
    <Grid fluid>
      <Row className="show-grid">
        <Col><Calendar compact value={rideDate} locale={zhTW.Calendar} onSelect={setRideDate} /></Col>
      </Row>
      {isShowWarning && <Row className="show-grid">
        <Col xs={1}></Col>
        <Col><span style={{ color: 'red' }}>{warningMessage}</span></Col>
      </Row>}
      <br></br>
      <Row className="show-grid">
        <Col xs={24}>
          <TimePicker
            value={rideTime}
            placeholder="選擇時間" hideMinutes={minute => minute % 5 !== 0}
            locale={zhTW.DateTimeFormats}
            editable={false}
            placement="topStart"
            block
            onChange={setRideTime} />
        </Col>
      </Row>

      <br></br>

      <br></br>
      <Row>
        <Col xs={12}><Button block appearance="ghost" onClick={() => {
          setRideDate(new Date());
          setRideTime(new Date());
        }}>全部重置</Button>
        </Col>

        <Col xs={12}>
          <Button block appearance="primary" onClick={() => {
            if (rideDate && rideTime) {
              setIsShowWarning(false);
              setWarningMessage("");
              let newDateStr = rideDate.toLocaleString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' +
                rideTime.toLocaleTimeString('zh-TW', { hourCycle: 'h24' });
              console.log("datetime string:", newDateStr);
              let newDateObj = new Date(newDateStr);
              console.log("datetime object:", newDateObj);
              let todayDateStr = new Date().toLocaleDateString();
              let todayDate = new Date(todayDateStr + ' 00:00:00');
              let diff = newDateObj.valueOf() - todayDate.valueOf();
              let diffInDays = diff / 1000 / 60 / 60 / 24;
              console.log("ride time and today days difference :", diffInDays);
              if (diffInDays >= 2) {
                if (diffInDays > 180) {
                  setWarningMessage("只能預約六個月內的日期");
                  setIsShowWarning(true);
                } else {
                  onDatetimeSelect(newDateObj);
                  setWarningMessage("");
                  setIsShowWarning(false);
                }

              } else {
                //alert('只能三天前預約');
                setWarningMessage("只能預約兩天後的日期，預訂當天或隔天請於官方LINE直言詢問");
                setIsShowWarning(true);
              }

            }
          }}>確認時間</Button>


        </Col>


      </Row>



    </Grid >

  )

}
